export const digestPath = '/digest/:threadId?';
